<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0"
      >
        <div class="md-transparent finanical-report-messages p-0">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 p-0">
                  <md-card class="if_card">
                    <md-card-header>Cessation</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header class="md-card-header-icon">
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >2020-2021 Cessation Rates</div>
                              </h4>
                              <!-- <h4 class="title text-left">2020-2021 Cessation Rates</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataCessationRates"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="years[key]"
                                      >{{ item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="pieChart.data"
                                :chart-options="pieChart.options"
                                chart-type="Pie"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >{{ this.chartData.title }}</div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    {{ this.chartData.title }}
                                  </h4>-->
                                </template>
                                <template slot="footer">
                                  <div class="md-layout">
                                    <div class="md-layout-item md-size-100">
                                      <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                                    </div>
                                    <div class="md-layout-item">
                                      <span
                                        v-for="(v, i) in pieChart.options
                                        .legendNames"
                                        :key="i"
                                        :class="`ct-series-${i}`"
                                      >
                                        <i class="fa fa-circle"></i>
                                        {{ v.name }} ({{ v.percentage }})
                                      </span>
                                    </div>
                                  </div>
                                </template>
                              </chart-card>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50" v-if="cmnText">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >Competitive Market Narrative</div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                              <h4 class="Performance Scores">
                                Competitive Market Narrative
                              </h4>-->
                              <div class="extra_space">
                                <p>
                                  {{cmnText.cessation}}
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>

                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 ">
                        <md-card class="md-card-profile px-4">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  <md-icon class="color-white">article</md-icon>Cessation
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                   <p>
                                     Cessation rates track the experience of business establishments, firms, small businesses, branches
                                      and startups doing business at the start of the time series, and still in operation today.<br><br>Firms
                                      which relocate but maintain independent operations are considered survivors if they do not move out
                                      of the jurisdiction being analyzed. Firms which become subsidiary locations, or whose location is
                                      terminated, are grouped with others which ceased operation. Any business entity which does not
                                      evidence ongoing operations (for example, by registering with government agencies, credit reporting
                                      services or business directories) is considered to have ceased viable operations and is classified
                                      in the "ceased operation" category.<br><br> Cessation rates occasionally reflect performance above
                                      100% or below 0% due to business migration among industries (changes in primary business line)
                                      or (in the case of location‐specific cessation rates) to business relocations. Migrants within a
                                      NAICS‐2 industry sector are considered as survivors in the in‐ migrant classification.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                      </div>

                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'tableDataMarketAnnualSalesy',
      showDialog: false,
      tableDataCessationRates: [],
      pieChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          showLabel: false,
          height: '250px',
          legendNames: [],
          labelInterpolationFnc: (value) => value,
        },
      },
    };
  },
  computed: {
    ...mapState({
      cessation: (state) => state.user.market_report.data.data['cessation'],
      years: (state) => state.user.market_report.data.years,
      chartData: (state) =>
        state.user.market_report.data.charts.test['Cessation'][0],
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'tableDataMarketAnnualSales';
    }

    this.switchView(section);
    let me = this;
    this.tableDataCessationRates = Object.entries(
      this.cessation
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataCessationRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.pieChart.options.legendNames = Object.entries(
      this.chartData.data
    ).map(([table, index]) => ({ name: table, percentage: index }));
    this.pieChart.data.series = Object.values(this.chartData.data);
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'tableDataMarketAnnualSales';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss"></style>
